var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.017,
    height: 31.218,
    viewBox: "0 0 26.017 31.218",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_118251",
    "data-name": "Trazado 118251",
    d: "M1404.759,674.7l-4.533-4.533a9.047,9.047,0,0,0-6.439-2.667h-5.873a6.51,6.51,0,0,0-6.5,6.5v18.211a6.512,6.512,0,0,0,6.5,6.5h13.008a6.511,6.511,0,0,0,6.5-6.5V681.138a9.049,9.049,0,0,0-2.667-6.439Zm-1.839,1.84a6.56,6.56,0,0,1,1.047,1.366h-5.647a1.3,1.3,0,0,1-1.3-1.3v-5.647a6.517,6.517,0,0,1,1.366,1.047l4.534,4.533Zm1.9,15.675a3.907,3.907,0,0,1-3.9,3.9h-13.008a3.907,3.907,0,0,1-3.9-3.9V674a3.907,3.907,0,0,1,3.9-3.9h5.873c.212,0,.422.011.631.03V676.6a3.907,3.907,0,0,0,3.9,3.9h6.474c.019.208.03.419.03.631v11.076Zm-5.584-5.878a1.3,1.3,0,1,1-1.84,1.839l-1.682-1.682v5.721a1.3,1.3,0,1,1-2.6,0v-5.721l-1.682,1.682a1.3,1.3,0,0,1-1.839-1.839l2.1-2.1a3.857,3.857,0,0,1,5.447,0l2.1,2.1Z",
    transform: "translate(-1381.409 -667.5)",
    fill: "#003763"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoUpload);
export default __webpack_public_path__ + "static/media/Icono-Upload.5241c28f5f6fd9c84a343dde5d6aa406.svg";
export { ForwardRef as ReactComponent };